import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { RecoilRoot } from 'recoil';

import { formatByLocale, fromISOString } from 'utils/date';

import { getVersionHistory } from 'RestAPIs/version-history';

import { Box } from '@mui/material';

import { DataGrid } from 'components/shared';

function DeployHistory() {
  const { t } = useTranslation();

  const { data: versionHistory = [] } = useQuery(
    ['VersionHistory'],
    async ({ signal }) => {
      const { data } = await getVersionHistory({ signal });
      return data;
    },
    {}
  );

  const rows = versionHistory.map((o) => ({
    ...o,
    deployedDate: fromISOString(o.deployed),
    deployed: formatByLocale(fromISOString(o.deployed), 'Pp')
  }));
  const columns = ['version', 'deployed'];

  const baseColumns = columns.map((key) => ({
    field: key,
    headerName: t(`deployHistory.${key}`),
    flex: 1
  }));

  return (
    <Box>
      <DataGrid rows={rows} columns={baseColumns} />
    </Box>
  );
}

export default function DeployHistoryRoot() {
  return (
    <RecoilRoot>
      <DeployHistory />
    </RecoilRoot>
  );
}
